<template>
<div v-if="player_actions">
    <messageModal v-if="showMessage" message="Le rapport a été mis à jour" @closeMessage="showMessage = false"></messageModal>
    <div class="grid_container">
      <div class="header_label">
          n°
      </div>
      <div class="header_label">Nom</div>
      <div class="header_label">Réu</div>
      <div class="header_label">TTM</div>
      <div class="header_label">Det</div>
      <div class="header_label">Int</div>
      <div class="header_label">Sor</div>
      <div class="header_label">TD</div>
      <div class="header_label">JPV</div>
      <div class="header_label">Expulsion*</div>
      <div class="header_label">Aggro</div>
      <div class="header_label">Xp Bonus</div>
      <div class="header_label">Blessure</div>
      <div></div>
      <template v-for="action of player_actions" v-if="player_actions.length > 0">
        <div class="input_field">
          <select class="small_label" v-model="action.player">
            <option v-for="player of getAvailablePlayers(action.player)"
                    v-bind:value="player.id">{{player.num}}</option>
          </select>
        </div>
        <div class="input_field text">
          {{getPlayerName(action.player)}}
        </div>
        <div class="input_field">
          <input type="number" min="0" class="input_font" v-model="action.nb_pass">
        </div>
        <div class="input_field">
          <input type="number" min="0" class="" v-model="action.nb_ttm">
        </div>
        <div class="input_field">
          <input type="number" min="0" class="" v-model="action.nb_det">
        </div>
        <div class="input_field">
          <input type="number" min="0" class="" v-model="action.nb_int">
        </div>
        <div class="input_field">
          <input type="number" min="0" class="" v-model="action.nb_cas">
        </div>
        <div class="input_field">
          <input type="number" min="0" class="" v-model="action.nb_td">
        </div>
        <div class="input_field">
          <select name="" class="" v-model="action.mvp">
            <option v-bind:value="true">oui</option>
            <option v-bind:value="false">non</option>
          </select>
        </div>
        <div class="input_field">
          <select name="" class="" v-model="action.nb_red_card">
            <option v-bind:value="0">non</option>
            <option v-bind:value="1">oui</option>
          </select>
        </div>
        <div class="input_field">
          <input type="number" min="0" class="line_input" v-model="action.nb_foul">
        </div>
        <div class="input_field">
          <input type="number" min="0" class="" v-model="action.bonus_xp">
        </div>
        <div class="input_field">
          <select name="" id="" class="" v-model="action.injury_type">
            <option value="null">pas de blessure</option>
            <option value="0">1-6 : Commotion</option>
            <option value="1">7-9 : Manque le prochain match</option>
            <option value="2">10-12 : Blessure persistante</option>
            <option value="4">13-14 / 1-2 : -1 en Ar</option>
            <option value="3">13-14 / 3 : -1 en M</option>
            <option value="8">13-14 / 4 : -1 en Cp</option>
            <option value="5">13-14 / 5 : -1 en Ag</option>
            <option value="6">13-14 / 6 : -1 en Fo</option>
            <option value="7">15-16 : la MOOOORT</option>
          </select>
        </div>
        <div>
          <button class="small alert line_but" :id="action.player" @click="removeActionLine($event)">
            <i class="fa fa-trash-o" aria-hidden="true"></i>
          </button>
        </div>
      </template>
    </div>
    <div class="row">
        <div class="large-3 columns">
            <button @click="addActionLine" class="full-width">Ajouter une ligne</button>
        </div>
        <div class="large-2 columns">
            <button  @click="validate(true)" class="full-width">Enregistrer</button>
        </div>
    </div>
</div>
<div v-else>
<spinner></spinner>
</div>
</template>

<script>
import spinner from '../common/spinner.vue'
import wizard from '../common/wizard.vue'
import { mapGetters } from 'vuex'
import store from '../../store/index.js'
import playerReport from '../../api/player-report.api'
import Vue from 'vue'
import messageModal from '../common/message-modal.vue'

export default {
  name: 'playerReportEditor',
  components: {
    spinner,
    messageModal,
    wizard
  },
  props: {
    'team_report_id': Number,
    'team_id': Number
  },
  data () {
    return {
      'player_actions': [],
      'player_injuries': [],
      'error_msg': null,
      'showMessage': false,
      'trListLoaded': false,
      'playerListLoaded': false
    }
  },
  computed:
  {
    ...mapGetters([
      'currentUser',
      'playerList'
    ]),
    ...mapGetters({
      current: 'playerReportList'
    })
  },
  watch: {
    current: function (newMr, oldState) {
      if (oldState === null && newMr) {
        this.trListLoaded = true
        if (this.playerListLoaded === true) {
          this.initDatas()
        }
      }
    },
    playerList: function (newPlayerList, oldPlayerList) {
      if (oldPlayerList === null && newPlayerList) {
        this.playerListLoaded = true
        if (this.trListLoaded === true) {
          this.initDatas()
        }
      }
    }
  },
  methods: {
    initDatas () {
      this.player_actions = this.current
      let cpt = 0
      this.player_actions.forEach(action => {
        action.player = this.current[cpt].player.id
        cpt++
      })
    },
    // ajoute un joueur du type qui va bien
    addActionLine (line) {
      let action = {}
      action.player = 0
      action.nb_pass = 0
      action.nb_ttm = 0
      action.nb_td = 0
      action.nb_det = 0
      action.nb_int = 0
      action.nb_cas = 0
      action.nb_foul = 0
      action.bonus_xp = 0
      action.mvp = false
      action.foul = 0
      action.nb_red_card = 0
      action.injury_type = null
      if (!this.player_actions) {
        Vue.set(this.player_actions, 0, action)
      } else {
        Vue.set(this.player_actions, this.player_actions.length, action)
      }
      action.team_report = this.team_report_id
    },
    removeActionLine ($event) {
      if (!$event.currentTarget.id) {
        return
      }

      var gcpt = 0
      this.player_actions.forEach(action => {
        if ((action.player !== undefined) && (action.player === parseInt($event.currentTarget.id, 10))) {
          // si l'actionLine a un Id, c'est qu'elle vient du back, on envoie donc un delete
          if (action.id) {
            this.player_actions.splice(gcpt, 1)
            playerReport.api.deletePlayerReport(action.id)
            .then(reponse => {
            }, error => {
              console.log('impossible to delete player report')
              console.log(error)
            })
          } else {
            // sinon on supprime juste la ligne du tableau
            this.player_actions.splice(gcpt, 1)
          }
        }
        gcpt++
      })
    },
    getPlayerName (id) {
      if ((this.playerList.length > 0) &&
          (id !== 0) &&
          (id !== undefined) &&
          (id !== null)) {
        return this.playerList.find(item => item.id === id).name
      }
      return 'choisissez un joueur'
    },
    getAvailablePlayers (playerId) {
      if (this.playerList.length === 0) {
        return
      }

      let avail = []
      this.playerList.forEach(player => {
        if (player.miss_next_game === false) {
          let pl = this.player_actions.find(action => action.player === player.id)
          if (pl === undefined) {
            avail.push(player)
          }
        }
      })
      // on rajoute le player selectionné
      if ((playerId !== null) && (playerId !== undefined) && (playerId !== 0)) {
        avail.push(this.playerList.find(player => player.id === playerId))
      }
      return avail
    },
    validate (withReload) {
      // le paramètre withReload sert à gérer le cas de l'enregistrement via le bouton "enregistrer"
      if (this.player_actions.length === 0) {
        return
      }

      // on supprime les lignes vides
      let cpt = 0
      this.player_actions.forEach(report => {
        if ((report.player === undefined) || (report.player === 0)) {
          this.player_actions.splice(cpt, 1)
        }
        if (report.injury_type === 'null') {
          report.injury_type = null
        }
        cpt++
      })

      // on trie les nouveaux rapports des existants
      let newReports = []
      let existingReports = []
      this.player_actions.forEach(report => {
        if (report.id) {
          existingReports.push(report)
        } else {
          newReports.push(report)
        }
      })

      let modif = false
      // si n'a pas de rapports existant
      if (newReports.length !== 0) {
       // on creé en masse les lignes ui n'ont pas d'id
        this.createNewReports(newReports, withReload)
        modif = true
      }
      if (existingReports.length !== 0) {
        // sinon on update en masse les ligne qui ont un id
        this.updateExistingReports(existingReports, withReload)
        modif = true
      }
      if (modif) {
        this.showMessage = true
      }
    },
    createNewReports (reportsArray, withReload) {
      playerReport.api.createPlayerReport(reportsArray)
      .then(response => {
        this.$store.dispatch('purgePlayerReportList')
        if (withReload === true) {
          store.dispatch('getPlayerReportListForTeamReport', this.team_report_id)
        }
      }, error => {
        console.log('cannot create player report')
        console.log(error)
      })
    },
    updateExistingReports (reportsArray, withReload) {
      playerReport.api.bulkUpdatePlayerReport(reportsArray)
      .then(response => {
        // store.dispatch('getPlayerReportListForTeamReport', this.team_report_id)
        this.$store.dispatch('purgePlayerReportList')
        if (withReload === true) {
          store.dispatch('getPlayerReportListForTeamReport', this.team_report_id)
        }
      }, error => {
        console.log('cannot update player report')
        console.log(error)
      })
    },
    getRosterIcon () {
      return '/static/imgs/team-icons/' + this.team.ref_roster.replace(/\s+/, '') + '.png'
    }
  },
  created () {
    store.dispatch('purgePlayerReportList')
    store.dispatch('invalidatePlayerList')
    store.dispatch('getPlayerReportListForTeamReport', this.team_report_id)
    store.dispatch('getPlayerListForTeam', this.team_id)
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.grid_container {
  width: 100%;
  display: grid;
  column-gap: 0.5rem;
  row-gap: 0.5rem;
  justify-content: stretch;
  grid-template-columns: 1fr 3fr repeat(7, 1fr) 1fr 1fr 1fr 3fr 1fr;
  margin-bottom: 1rem;
}

.header_label {
  font-size: 0.8rem;
  background-color: #E9EDEF;
  display: flex;
  align-items: center;
  justify-content: center;
}

.input_field {
  font-size: 0.9rem;
}

.input_field.text {
  display: flex;
  align-items: center;
  justify-content: center;
}

.input_field > select {
  margin-bottom: 0;
  font-size: 0.9rem;
  color: #2c3e50;
}
.input_field > input {
  margin-bottom: 0;
  font-size: 0.9rem;
  color: #2c3e50;
}

.small_label {
  font-size: 0.9rem;
}

.line_but {
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// player-report-editor.vue?5163106f